module.exports = __webpack_public_path__ + "static/img/ent-98.b494463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-98.jpg
// module id = A8RG
// module chunks = 51